// extracted by mini-css-extract-plugin
export default {"tag":"Person__tag___NvddB","closeIcon":"Person__closeIcon___Q72Cx","personName":"Person__personName___Tz2ac"};